import { ErrorData } from '@b2chat/chat-center-sdk';
import { Box, Portal } from '@material-ui/core';
import { ReportedCAPIEventSnackbar } from '@src/components/CAPI/ReportCAPIEventPopover';
import AddConverTagButton from '@src/components/ChatMessageComposer/AddConverTagButton';
import {
  fetchConverTags,
  requestConverTagsError,
  setForceToUpdateTagList,
  toggleTagAssign,
} from '@src/reducers/tags';
import {
  getConverAssignedTags,
  getConverTagsListViewState,
} from '@src/selectors/tags';
import {
  deleteChatTagPOST,
  searchChatTagsPOST,
} from '@src/services/tags.service';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RowTagsList from './RowTagsList';
import './tag-list_style.css';
import { AnyTag, ConversationTag } from './types';
import { getOldTagData, WIDTH_CHATLIST, WIDTH_CONTEXT_MENU } from './utils';

const HEIGTH_OF_TAGS_LIST_DIV = 30;
interface IConverTagsListView {
  isContextMenuOpened?: boolean;
  withoutContextMenu?: boolean;
  currentCAPIEvents: string[];
}

const ConverTagsListView: React.FC<IConverTagsListView> = ({
  isContextMenuOpened,
  withoutContextMenu,
  currentCAPIEvents,
}) => {
  const dispatch = useDispatch();

  const { chatId, botId, departmentId } = useSelector(
    getConverTagsListViewState
  );
  const assignedTags = useSelector(getConverAssignedTags);

  const updateTags = useCallback(async () => {
    if (botId && chatId) {
      try {
        const response = await searchChatTagsPOST({
          botId,
          chatId,
          departmentId,
        });
        dispatch(fetchConverTags(response as ConversationTag[]));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('error: ', error);
        dispatch(requestConverTagsError(error as ErrorData));
      } finally {
        dispatch(setForceToUpdateTagList(true));
      }
    }
  }, [botId, chatId, departmentId, dispatch]);

  const onDeleteTag = async (curTag: AnyTag) => {
    const tag = getOldTagData(curTag) as ConversationTag;
    tag.assigned = false;
    try {
      dispatch(toggleTagAssign({ tagName: tag.tagName, checked: false }));
      await deleteChatTagPOST({ chatId, tag });
    } catch (error) {
      dispatch(requestConverTagsError(error as ErrorData));
      dispatch(toggleTagAssign({ tagName: tag.tagName, checked: true }));
    }
  };

  const onTagAssigned = (tag: AnyTag, capiEvent: boolean) => {
    if (capiEvent) setCAPIEventSent(tag.conversionType || '');
  };

  useEffect(() => {
    updateTags();
  }, [updateTags]);

  const [capiEventSent, setCAPIEventSent] = useState('');

  const snackbar = (
    <Portal container={document.getElementById('chat-timeline')}>
      <ReportedCAPIEventSnackbar
        event={capiEventSent}
        onClose={() => setCAPIEventSent('')}
      />
    </Portal>
  );

  if (withoutContextMenu)
    return (
      <>
        <RowTagsList
          tags={assignedTags}
          heigthOfTagsListDiv={HEIGTH_OF_TAGS_LIST_DIV}
          position="left"
          handleOnDelete={onDeleteTag}
          customAddButton={
            <AddConverTagButton
              withoutLabel
              position="overRight"
              grayButton
              currentCAPIEvents={currentCAPIEvents}
              onAssigned={onTagAssigned}
            />
          }
        />
        {snackbar}
      </>
    );

  return (
    <>
      {!assignedTags.length ? (
        <Box width="100px" />
      ) : (
        <Box
          className="ConsoleTagsListView"
          style={{
            width: `calc(100vw - ${WIDTH_CHATLIST} - ${
              isContextMenuOpened ? WIDTH_CONTEXT_MENU : 0
            }`,
          }}
        >
          <Box display="flex" alignItems="center" style={{ gap: '70px' }}>
            <RowTagsList
              tags={assignedTags}
              heigthOfTagsListDiv={HEIGTH_OF_TAGS_LIST_DIV}
              position="left"
              handleOnDelete={onDeleteTag}
            />
            <Box />
          </Box>
        </Box>
      )}
      {snackbar}
    </>
  );
};

export default ConverTagsListView;
